module.exports = __webpack_public_path__ + "img/slide13.3bf8f92a.png";